import type { DiveSite } from '../types/DiveSite';
import { userProfileService } from '../services/userProfileService';
import { HomeSiteRef, buildRegions, countrySlug, regionForHomeSite } from './regions';

/**
 * Tells the server which region the diver's home site is in. The dive-site catalog lives in this app, so the
 * server can't work it out itself; it needs the answer to list the diver as a local of that region. Safe to
 * repeat — the server also repairs the rest of the diver's region memberships each time.
 */
export const reportHomeRegion = async (home: HomeSiteRef, sites: DiveSite[]): Promise<void> => {
  const region = regionForHomeSite(home, buildRegions(sites));
  await userProfileService.setHomeRegion(region?.slug ?? null, region?.country ? countrySlug(region.country) : null);
};
